import React from 'react'

const Backend = () => {
    return (
        <div className="skills_content">
            <h3 className="skills_title">Backend Developer</h3>

            <div className="skills_box">
                <div className="skills_group">
                    <div className="skills_data">
                        <i className="bx bx-badge-check"></i>

                        <div>
                            <h3 className="skills_name">PHP</h3>
                            <span className="skills_level">Basic</span>
                        </div>
                    </div>

                    <div className="skills_data">
                        <i className="bx bx-badge-check"></i>

                        <div>
                            <h3 className="skills_name">Node.JS</h3>
                            <span className="skills_level">Intermediate</span>
                        </div>
                    </div>

                    <div className="skills_data">
                        <i className="bx bx-badge-check"></i>

                        <div>
                            <h3 className="skills_name">PYTHON</h3>
                            <span className="skills_level">Intermediate</span>
                        </div>
                    </div>
                    <div className="skills_data">
                        <i className="bx bx-badge-check"></i>

                        <div>
                            <h3 className="skills_name">C++</h3>
                            <span className="skills_level">Intermediate</span>
                        </div>
                    </div>
                    <div className="skills_data">
                        <i className="bx bx-badge-check"></i>

                        <div>
                            <h3 className="skills_name">LARAVEL</h3>
                            <span className="skills_level">Intermediate</span>
                        </div>
                    </div>
                </div>

                <div className="skills_group">
                    <div className="skills_data">
                        <i className="bx bx-badge-check"></i>

                        <div>
                            <h3 className="skills_name">MYSQL</h3>
                            <span className="skills_level">Intermediate</span>
                        </div>
                    </div>

                    <div className="skills_data">
                        <i className="bx bx-badge-check"></i>

                        <div>
                            <h3 className="skills_name">MONGO DB</h3>
                            <span className="skills_level">Intermediate</span>
                        </div>
                    </div>

                    <div className="skills_data">
                        <i className="bx bx-badge-check"></i>

                        <div>
                            <h3 className="skills_name">Flet</h3>
                            <span className="skills_level">Beginner</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Backend